/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_ViolenceInputs */



/**
* | output |
* | --- |
* | "Violence/Fantasy Violence" |
*
* @param {Subtitle_Export_Vchip_ViolenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_violence = /** @type {((inputs?: Subtitle_Export_Vchip_ViolenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_ViolenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Violence/Violence fantastique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gewalt/Fantasy-Gewalt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Violenza/Violenza fantastica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Насилие/Фантастическое насилие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Violencia/Violencia de fantasía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暴力/幻想暴力")
	if (locale === "ja") return /** @type {LocalizedString} */ ("暴力／ファンタジー暴力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हिंसा/काल्पनिक हिंसा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Violência/Violência Fantástica")
	return /** @type {LocalizedString} */ ("Violence/Fantasy Violence")
});